import Mutations from '../../odata/mutations';

export default { ...new Mutations('stockItemFile'), ...new Mutations('stockItemFiles') };
